// extracted by mini-css-extract-plugin
export default {"wrap":"ReactivateUser_wrap__2HM2v","description":"ReactivateUser_description__E9grL","error":"ReactivateUser_error__WJfFB","spinner":"ReactivateUser_spinner__A3J4v"};